import {
	ADMINCURRENCYCODE_SUCCESS,
	ADMINCURRENCYCODE_FAILED,
	RESET_ADMINCURRENCYCODE,
	LOADING_ADMINCURRENCYCODE,
	NETWORK_ERROR_ADMINCURRENCYCODE
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetAdminCurrencyCode = () => {
	return { type: RESET_ADMINCURRENCYCODE };
};

const adminCurrencyCode = (userData, authTokenIs) => async (dispatch) => {
	dispatch({ type: LOADING_ADMINCURRENCYCODE });
	await adminServices
		.post("getDefaultCurrencyAdmin", userData, { headers: { AuthToken: authTokenIs } })
		.then((res) => {
			switch (res.data.status) {
				case "success":
					dispatch(adminCurrencyCodesuccess(res.data));
					break;
				default:
					dispatch(adminCurrencyCodeFailed(res.data));
					break;
			}
		})
		.catch((err) => {
			dispatch({
				type: NETWORK_ERROR_ADMINCURRENCYCODE,
				payload: err
			});
		});
};
function adminCurrencyCodesuccess(data) {
	return {
		type: ADMINCURRENCYCODE_SUCCESS,
		payload: data
	};
}
function adminCurrencyCodeFailed(data) {
	return {
		type: ADMINCURRENCYCODE_FAILED,
		payload: data
	};
}

export { resetAdminCurrencyCode, adminCurrencyCode };
